'use client';
import React from 'react';
import { MarketingPageComponentProps } from '@services/launches/fetchLaunchMarketingContent';
import { Box, List, ListItem, Stack } from '@mui/material';
import ReactHtmlParser from '@libs/reactHtmlParser';
import { Link } from '@components/Link';
import DynamicLogo from '@components/DynamicLogo';
import ParallaxText from '@components/ParallaxText';
import cn from './style.module.scss';

type MenuItem = {
  url: string;
  label: string;
};
export default function WestminsterTowerFooter(
  props: MarketingPageComponentProps
) {
  const westminsterTowerFooterAddress =
    props.locale.section.westminsterTowerFooterInformation || [];
  const westminsterTowerFooterNavigation =
    props.locale.section.westminsterTowerFooterNavigation || [];
  return (
    <Stack component="footer" className={cn.westminsterTowerFooterWrapper}>
      <Box className={cn.westminsterTowerFooterInner}>
        <Box className={cn.westminsterTowerFooterContent}>
          <Box className={cn.westminsterTowerFooterMenu}>
            <List className={cn.westminsterTowerFooterList}>
              {westminsterTowerFooterNavigation?.map((item: MenuItem) => (
                <ListItem key={item.url}>
                  <Link
                    url={item.url}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {ReactHtmlParser(item.label)}
                  </Link>
                </ListItem>
              ))}
            </List>
          </Box>
          <Box className={cn.westminsterTowerFooterCompany}>
            <Box className={cn.westminsterTowerFooterCompany__element}>
              <DynamicLogo
                logoImage={props?.images?.westminster_tower_lsq_logo?.src}
                alt={'Wimbledon Bridge Logo'}
              />
            </Box>
            {/* <Box className={cn.westminsterTowerFooterCompany__address}>
              {westminsterTowerFooterAddress?.map(
                (item: string, index: number) => (
                  <p key={index}>{item}</p>
                )
              )}
            </Box> */}
          </Box>
          <Box className={cn.westminsterTowerFooterCopyright}>
            <Box className={cn.westminsterTowerCopyrightElement}>
              <ParallaxText
                variant="p"
                animationType="slideInBottom"
                animationDuration={500}
              >
                {ReactHtmlParser(
                  props.locale.section.westminsterTowerFooterCopyright
                )}
              </ParallaxText>
            </Box>
          </Box>
        </Box>
      </Box>
    </Stack>
  );
}
